import { render, staticRenderFns } from "./TrustedSection.vue?vue&type=template&id=0456aa78&scoped=true"
import script from "./TrustedSection.vue?vue&type=script&lang=js"
export * from "./TrustedSection.vue?vue&type=script&lang=js"
import style0 from "./TrustedSection.vue?vue&type=style&index=0&id=0456aa78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0456aa78",
  null
  
)

export default component.exports